import React from 'react'
import {CircularProgress} from "@mui/material";
import useLoadCourse from "../../../courses/utils/useLoadCourse";
import CourseCard from "../../../courses/card/course/CourseCard";

const StatisticsCourseSummary = ({courseKey}) => {
    const {course, loading} = useLoadCourse(courseKey)

    if (loading) {
        return <CircularProgress/>
    }

    return <CourseCard course={course} headerSize={18} textSize={16}/>

}
export default StatisticsCourseSummary
